<template>
  <div class="troops">
    <ul>
      <li v-for="(dropItem, i) in drops" :key="i">
        <img :src="getDropImageSrc(dropItem)" alt="drop" />
        <span>{{ getDropName(dropItem) }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import {
  DropItemCategory,
  IDropItemDefinition,
} from "../../game/shared/JsonDefinitions";
export default defineComponent({
  props: {
    drops: {
      type: Object as PropType<IDropItemDefinition[]>,
      required: true,
    },
  },
  methods: {
    getDropImageSrc(dropItem: IDropItemDefinition) {
      const textureName =
        dropItem.category == DropItemCategory.Resource
          ? "resources"
          : dropItem.category == DropItemCategory.Material
          ? "materials"
          : dropItem.category == DropItemCategory.Equipment
          ? "equipment"
          : "buffs";
      const url =
        import.meta.env.VITE_SERVER_URL +
        `/assets/drops/${textureName}/${dropItem.id}.png`;
      return url;
    },
    getDropName(dropItem: IDropItemDefinition) {
      return `${dropItem.amount} x ${dropItem.name}`;
    },
  },
});
</script>

<style>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
img {
  width: 48px;
  height: 48px;
  margin-top: 4px;
}
</style>
